import React from "react";
import styled from "styled-components";

import Gettext from "./common/Gettext";
import Tooltipy from "./Tooltipy";
import Floatipy from "./Floatipy";
import { VerifiedIcon, UnverifiedIcon, PendingIcon } from "./Icons";

const IconContainer = styled.div`
  display: inline-block;
  position: relative;
  vertical-align: middle;
`;

export const VERIFICATION_STATUS_UNVERIFIED = 0;
export const VERIFICATION_STATUS_SENT       = 1;
export const VERIFICATION_STATUS_APPROVED   = 2;
export const VERIFICATION_STATUS_DECLINED   = 3;

export function getVerificationStatusText(status) {
  switch (status) {
    case VERIFICATION_STATUS_APPROVED:
      return <Gettext>Account is verified</Gettext>;
    case VERIFICATION_STATUS_UNVERIFIED:
      return <Gettext>Account is not verified</Gettext>;
    case VERIFICATION_STATUS_SENT:
      return <Gettext>Pending confirmation</Gettext>;
    case VERIFICATION_STATUS_DECLINED:
      return <Gettext>Verification of your account has been rejected!</Gettext>;
    default:
      return null;
  }
}

export function getVerificationStatusIcon(status) {
  switch (status) {
    case VERIFICATION_STATUS_APPROVED:
      return <VerifiedIcon />;
    case VERIFICATION_STATUS_UNVERIFIED:
      return <UnverifiedIcon />;
    case VERIFICATION_STATUS_SENT:
      return <PendingIcon />;
    case VERIFICATION_STATUS_DECLINED:
      return <UnverifiedIcon />;
    default:
      return null;
  }
}

const VerificationIcon = ({ status, floatipy, notooltip }) => (
  <IconContainer>
    {notooltip
     ? getVerificationStatusIcon(status)
     : floatipy
      ? <Floatipy tooltip={getVerificationStatusText(status)}>
        {getVerificationStatusIcon(status)}
      </Floatipy>
      : <Tooltipy tooltip={getVerificationStatusText(status)}>
        {getVerificationStatusIcon(status)}
      </Tooltipy>
    }
  </IconContainer>
);

export default VerificationIcon;


// WEBPACK FOOTER //
// ./src/components/VerificationStatus.js